import React from 'react';
import '../css/Loading/loadingStyles.css';

export const Loading = () => {
    return (
        <div id="loading-s5HzZ7nkzdCZ6X4C">
            <div id="load-spinner-3T189dsaddjio1">
                <div className="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </div>
    );
}